/**
 * “科创中国”美团青山环保科技创新示范项目简介
 */
import React, { useState } from 'react';
import './index.scss';
import { Tabs } from '@roo/roo';
const { Pane: TabPane } = Tabs;
import { KechuangHeader } from '../../../components/KechuangHeader/KechuangHeader';
import Partner from '../../../components/Partner/Partner';
import { projectData } from './projectData';

const yearArray = ['2023', '2021'];

const ProjectItem = ({ item, index }) => {
  const { name, organization, introduction, reason, imgurl } = item;
  const indexString = index < 9 ? `0${index + 1}` : index + 1;
  return (
    <div className="laureates-item">
      <div className="content">
        <div className="laureates-item-title">
          <span className="laureates-item-title-index">{indexString}</span>
          {name}
        </div>
        <div className="subtitle">申报单位</div>
        <div className="laureates-item-organization">
          {organization.map((item, index) => (
            <div className="text" key={index}>
              {item}
            </div>
          ))}
        </div>
        <div className="subtitle">项目介绍</div>
        <div className="laureates-item-introduction">
          {introduction.map((item, index) => (
            <div className="text" key={index}>
              {item}
            </div>
          ))}
        </div>
        <div className="subtitle">入选理由</div>
        <div className="laureates-item-reason">
          {reason.map((item, index) => (
            <div className="text" key={index}>
              {item}
            </div>
          ))}
        </div>
        <div className="img-ctn">
          <img src={imgurl} alt="" />
        </div>
      </div>
    </div>
  );
};

const laureates = () => {
  const [activeTab, setActiveTab] = useState(yearArray[0]);
  const onTabClick = (value) => {
    setActiveTab(value);
  };
  return (
    <div className="environment-laureates">
      <KechuangHeader />
      <div className="about-laureates block-container marker" style={{ marginTop: 90 }}>
        <span className="title">历届入选项目</span>
        <div className="laureates">
          <Tabs className="laureates-tab" value={activeTab} onTabClick={onTabClick}>
            {yearArray.map((year) => (
              <TabPane name={year} label={year} key={year}>
                <div className="laureates-list">
                  {projectData[year].map((item, index) => (
                    <ProjectItem item={item} index={index} />
                  ))}
                </div>
              </TabPane>
            ))}
          </Tabs>
          <div className="partner-wrap">
            <Partner />
          </div>
        </div>
      </div>
    </div>
  );
};

export default laureates;
